import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Phone } from "lucide-react";
import { API, LOGO_URL } from "@/config";

const LoginPage = () => {
  const [whatsapp, setWhatsapp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const cleanPhone = whatsapp.replace(/[^\d+]/g, "");
    if (cleanPhone.replace(/\D/g, "").length < 10) { setError("Please enter a valid WhatsApp number"); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/send-otp`, {
        phone: cleanPhone,
        purpose: "login",
      });
      navigate("/verify-otp", { state: { phone: data.phone || cleanPhone, purpose: "login" } });
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Could not send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="finance-app min-h-screen flex items-center justify-center p-4" data-testid="login-page">
      <div className="finance-card w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="SubiWealth" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-800">Welcome Back</h1>
          <p className="text-gray-500 mt-2">Sign in to your SubiWealth account</p>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg mb-4" data-testid="login-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number</label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
              <input type="tel" data-testid="login-whatsapp" className="w-full pl-10 pr-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-teal-400 focus:ring-2 focus:ring-teal-100" placeholder="+91 98765 43210" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} required />
            </div>
            <p className="text-xs text-gray-500 mt-1">We'll send a 6-digit OTP to your WhatsApp</p>
          </div>

          <button type="submit" data-testid="login-send-otp" className="w-full nav-btn primary py-3" disabled={loading}>
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600 text-sm">
          Don't have an account?{" "}
          <button onClick={() => navigate("/register")} className="text-teal-600 font-medium hover:underline" data-testid="go-to-register">Sign Up</button>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
